import icon1 from '../../../Assets/Icons/build.svg';
import icon2 from '../../../Assets/Icons/coins.svg';
import icon3 from '../../../Assets/Icons/team.svg';
import icon4 from '../../../Assets/Icons/question.svg';
import icon5 from '../../../Assets/Icons/light-bulb.svg';
import icon6 from '../../../Assets/Icons/experience.svg';

import image1 from '../../../Assets/Cards/enjoyCard1.webp';
import image2 from '../../../Assets/Cards/enjoyCard2.webp';
import image3 from '../../../Assets/Cards/enjoyCard3.webp';


import health from '../../../Assets/Icons/health.svg';
import family from '../../../Assets/Icons/family.svg';
import generous from '../../../Assets/Icons/generous.svg';
import financial from '../../../Assets/Icons/financial.svg';
import community from '../../../Assets/Icons/community.svg';
import evolve from '../../../Assets/Icons/evolve.svg';


export const careCards=[
    {
        icon:health,
        title:"Health & Wellness ",
        desc:"HostDesign offers comprehensive coverage that meets the needs of our diverse workforce. Award-winning mental health, wellbeing and family support is available to all Hostdesigner worldwide."
    },
    {
        icon:family,
        title:"Family Support",
        desc:"Here at HostDesign, we care about the well-being of families in every shape and size. From paid parental leave and fertility and family forming benefits, HostDesign provides an all-inclusive support system for working families."
    },
    {
        icon:generous,
        title:"Generous Time Off",
        desc:"To ensure Hostdesigner can 10x both inside and outside of work, HostDesigner offers market-leading flexible time off and holidays (yes, that includes birthdays!) so Hostdesigner can recharge when they need it, as well as 3 days annually for Volunteer Time Off (VTO)!"
    },
    {
        icon:financial,
        title:"Financial Benefits",
        desc:"When we say, 'Be an owner. It's your company.' we really mean it. Every Boxer receives an equity award when they are hired, along with access to participate in our best-in-class Employee Stock Purchase Plan. In addition to equity"
    },
    {
        icon:community,
        title:"Community",
        desc:"HostDesign is a place where community comes first and it shows up in various wasy: 18 employee led affinity groups we call our employee resource communities, 20+ employee interest groups (ranging from peloton and yoga, to mindfulness and cooking), global virtual community events and programs "
    },
    {
        icon:evolve,
        title:"Evolving Workplace",
        desc:"As the world continues to evolve, HostDesign believes in a hybrid model of work. Hostdesigner are powering how the world works together, both in office, from home, and/or remotely. Collaboration through the Content Cloud makes it happen. "
    }
]
export const enjoyCards = [
    {
        backgroundImage:image1,
        title:"Table Tennis time",
        delay:100
    },
    {
        backgroundImage:image2,
        title:"hostFamily Day",
        delay:200
    },
    {
        backgroundImage:image3,
        title:"Team Hangout",
        delay:300
    }
]
export const aboutValues = [
    {
        icon:icon1,
        title:"Build Together",
        desc:"We are respectful, sharing, teaching and learning. We are smart, weird, fun and above all, we're a team and want to see each other succeed personally and professionally.",
        bgColor:"#F1EBFF",
        bgColor2:"#622AF2"
    },
    {
        icon:icon2,
        title:"Take Ownership",
        desc:"Everyone at Marvel believes that the product represents who we are and the hard work we do. We want to feel proud of this platform that's shared with the world.",
        bgColor:"#ec63233b",
        bgColor2:"#EC6423"
    },
    {
        icon:icon3,
        title:"Be Scrappy",
        desc:"We're a startup so urgency counts. The perfect moment to do something rarely arrives so whilst thinking long term is important - endless planning can hold us back from accelerating.",
        bgColor:"#ffbf002d",
        bgColor2:"#FFC000"
    },
    {
        icon:icon4,
        title:"Be Curious",
        desc:"The opportunity to learn is everywhere and we encourage each other to constantly ask questions, dive into data and collaborate with other teams and our users.",
        bgColor:"#02eb0223",
        bgColor2:"#02EB02"
    },
    {
        icon:icon5,
        title:"Say What You Think",
        desc:"Ideas, praise and feedback can, and should, come from everyone within Hostdesign. Regardless of team or title, all knowledge and enthusiasm is welcome and appreciated.",
        bgColor:"#ff4f5b2f",
        bgColor2:"#FF4F5A"
    },
    {
        icon:icon6,
        title:"Think in Experiences",
        desc:"Product and experiences are part of our DNA, it's not just the software we're building but how we approach everything.",
        bgColor:"#17a8ec25",
        bgColor2:"#17A7EC"
    }
]

